import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const menuCaterogy = {
  category: `${baseURL}/menu-categories`
};

export default menuCaterogy;
